import React from "react";

import AuthProvider from "@contexts/AuthProvider";
import DeviceInfoProvider from "@contexts/DeviceInfoProvider";
import FeatureFlagProvider from "@contexts/FeatureFlagProvider";
import OptimizelyProvider from "@contexts/OptimizelyProvider";
import FilterProvider from "@contexts/FilterProvider";
import { Bootstrapper } from "@components/Bootstrapper";
import MaintenanceProvider from "@contexts/MaintenanceProvider";

const Provider = ({ children }) => (
  <MaintenanceProvider>
    <FeatureFlagProvider>
      <DeviceInfoProvider>
        <AuthProvider>
          <Bootstrapper>
            <OptimizelyProvider>
              <FilterProvider>{children}</FilterProvider>
            </OptimizelyProvider>
          </Bootstrapper>
        </AuthProvider>
      </DeviceInfoProvider>
    </FeatureFlagProvider>
  </MaintenanceProvider>
);

export default Provider;
